// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"191":"bec7e06e","284":"33a4e58f","321":"33a4e58f","570":"40d2894a","585":"13ad4392","784":"6278d8cf","824":"12a8d509","835":"9f10336b","874":"86e7cb7e"}[chunkId] + ".chunk.css";
};